import "core-js/stable";
import "regenerator-runtime/runtime";
import 'element-matches-polyfill';
import 'element-closest-polyfill';

import {Env} from './components/config/env';
import {Settings} from './components/config/settings';
import {Snippet} from './components/config/snippet';
import {Customization} from './components/config/customization';
import {AppConfig} from './components/config/config';

import {AppLibrary} from './components/app-library';
import {Loader} from './components/loader';

import {Application} from './components/application';

const env = new Env();
const APP_NAME = env.appName;

const settings = new Settings(APP_NAME);
const snippet = new Snippet(APP_NAME);
const customization = new Customization(APP_NAME);
const config = new AppConfig(env, settings, snippet, customization);
const library = new AppLibrary(APP_NAME, snippet);

const theGreatLoader = new Loader(library, APP_NAME);

theGreatLoader.enableSelectorPicker(
    (pageType) => {
      return true;
    },
);

theGreatLoader.addResources(env.cdnCommonPath + 'common.css');
theGreatLoader.addResources(env.cdnStorePath + snippet.shopHash + '.js?' + Date.now());
// theGreatLoader.addResources(env.cdnStorePath + snippet.shopHash + '.css');

theGreatLoader.addResources(env.cdnJsLibPath + 'spurit.global-2.x.min.js');


theGreatLoader.run(($, currentPage) => {
  config.init();
  if (!config.isAppActive(currentPage)) {
    return;
  }
  Spurit.global.onReady(
    [
      'atc', 'selectors', 'cart', 'checkout', 'prices'
    ],
    () => new Application(config, library, currentPage),
    {
      checkout: {
        hash: config.snippet().shopHash,
        app_id: env.appId,
        app_name: APP_NAME,
      },
    },
  );
});